"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _ossUpload = require("@/utils/ossUpload");
var _download = require("@/utils/download");
var _goodsListActive = require("@/api/operationManagement/goodsListActive");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ActivePop',
  components: {},
  data: function data() {
    var validateFile = function validateFile(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error('请上传文件'));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      openType: '1',
      id: '',
      dialogVisible: false,
      popTitle: '',
      ruleForm: {
        name: '',
        type: '',
        headPhoto: '',
        listType: '',
        color: '#FFFFFF',
        time: '',
        fileList: []
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择平台类型',
          trigger: 'change'
        }],
        headPhoto: [{
          required: true,
          message: '请上传头图',
          trigger: 'change'
        }],
        listType: [{
          required: true,
          message: '请选择列表样式',
          trigger: 'change'
        }],
        fileList: [{
          required: true,
          message: '请上传文件',
          validator: validateFile,
          trigger: 'change'
        }]
      },
      typeOptions: [{
        value: 'TB',
        label: '淘宝'
      }, {
        value: 'JD',
        label: '京东'
      }, {
        value: 'PDD',
        label: '拼多多'
      }, {
        value: 'DY',
        label: '抖音'
      }, {
        value: 'WPH',
        label: '唯品会'
      }]
    };
  },
  created: function created() {},
  methods: {
    down: function down() {
      (0, _download.selfDownload)();
    },
    timeC: function timeC() {
      if (this.ruleForm.time === null) {
        console.log(this.ruleForm.time);
        this.ruleForm.time = [];
      }
    },
    handleRemove: function handleRemove() {
      this.ruleForm.fileList = [];
    },
    change: function change(file, fileList) {
      this.ruleForm.fileList = fileList;
      this.$refs.ruleForm11.validateField('fileList');
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var obj = new FormData();
          var buffSend = {
            '1': _goodsListActive.addAct,
            '2': _goodsListActive.updateAct
          };
          if (_this.openType === '1') {
            obj.append('file', _this.ruleForm.fileList[0].raw);
          }
          if (_this.openType === '2') {
            obj.append('id', _this.id);
          }
          obj.append('activityName', _this.ruleForm.name);
          obj.append('platformCode', _this.ruleForm.type);
          obj.append('picUrl', _this.ruleForm.headPhoto);
          obj.append('type', _this.ruleForm.listType);
          obj.append('color', _this.ruleForm.color);
          obj.append('startTime', _this.ruleForm.time[0] ? _this.ruleForm.time[0] : '');
          obj.append('endTime', _this.ruleForm.time[1] ? _this.ruleForm.time[1] : '');
          buffSend[_this.openType](obj).then(function (res) {
            if (res.data) {
              _this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this.onClose();
              _this.$emit('success', _this.openType);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    open: function open(val) {
      var _this2 = this;
      console.log(val, '=============');
      this.openType = val.openType;
      if (val.openType === '1') {
        setTimeout(function () {
          _this2.id = '';
          _this2.popTitle = '商品列表活动添加';
        });
        var end = new Date();
        var start = new Date();
        end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
        start.setHours(0, 0, 0, 0); // 设置为00:00:00
        end.setHours(23, 59, 59, 999); // 设置为23:59:59
        this.ruleForm.time = [this.formatDate(start), this.formatDate(end)];
        this.dialogVisible = true;
      } else if (val.openType === '2') {
        setTimeout(function () {
          _this2.ruleForm.name = val.activityName;
          _this2.ruleForm.type = val.platformCode;
          _this2.ruleForm.headPhoto = val.picUrl;
          _this2.ruleForm.listType = val.type;
          _this2.ruleForm.color = val.color;
          if (val.startTime && val.endTime) {
            _this2.ruleForm.time = [val.startTime, val.endTime];
          }
          _this2.id = val.id;
          _this2.popTitle = '商品列表活动编辑';
        });
        this.dialogVisible = true;
      }
    },
    onClose: function onClose() {
      this.resetForm('ruleForm11');
      this.dialogVisible = false;
      this.id = '';
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              console.log(pictureUrl);
              this.ruleForm.headPhoto = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }()
  }
};